import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from 'axios';
import { G_API } from '../../constants/globalVar';
import ReactGA from 'react-ga4';
import SocialShareButtons from "../Button/SocialShareButtons";

const departmentsList = [
    { name: "Hta-Hnaung Centre for Academic Studies", code: "HCS" },
    { name: "Academic Affairs and Quality Control Department", code: "AQCD" },
    { name: "Programme Support Department", code: "PSD" }
];

export default function DetailPage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [item, setItem] = useState(null);
    const [loading, setLoading] = useState(true);
    const [formattedDate, setFormattedDate] = useState('');
    const [formattedTime, setFormattedTime] = useState('');

    useEffect(() => {
        setLoading(true);
        axios.get(`${G_API}department-articles/${id}`)
            .then((response) => {
                const articleData = response.data.DATAS;
                setItem(articleData);
                
                if (articleData?.updated_at) {
                    const updatedAt = new Date(articleData.updated_at);
                    setFormattedDate(updatedAt.toLocaleDateString());
                    setFormattedTime(updatedAt.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }));
                }
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching article details:", error);
                setLoading(false);
            });
    }, [id]);

    const handleShareClick = () => {
        ReactGA.event({
            category: 'Department Article',
            action: 'depart_article_share_btn_clicked',
            label: item ? item.title : 'Department Article',
        });
    };

    const handleDepartmentNavigation = (departmentCode) => {
        navigate(`/departments#${departmentCode}`);
        
        if (window.location.pathname.includes('/departments')) {
            window.location.hash = departmentCode;
        }
    };

    if (loading) {
        return (
            <div className="d-flex align-items-center justify-content-center w-100" style={{ minHeight: "60vh" }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading Article...</span>
                </div>
            </div>
        );
    }

    if (!item) {
        return (
            <div className="text-center py-5 my-5">
                <h4 className="text-muted">Article not found</h4>
                <button className="btn btn-primary rounded-pill mt-3" onClick={() => navigate(-1)}>Go Back</button>
            </div>
        );
    }

    return (
        <>
            {/* Header spacer block, Do not change height */}
            <div id="header-carousel" className="carousel slide" data-bs-ride="carousel" style={{ height: '180px', backgroundColor: '#002' }}></div>

            <div className="department-detail container lh-lg">
                <div className="border bg-white rounded shadow-sm my-4 mx-auto py-4 px-3 p-md-5" style={{ maxWidth: '800px' }}>
                    
                    <div className="d-flex text-muted small mb-3 border-bottom pb-2">
                        <span>Published: {formattedDate} — {formattedTime}</span>
                    </div>

                    <h2 className="text-uppercase fw-bold text-dark mb-4 text-center text-md-start">
                        {item.title}
                    </h2>

                    <div className="article-body my-4 text-secondary">
                        <div dangerouslySetInnerHTML={{ __html: item.paragraph1 }} />
                    </div>

                    {item.image1 && (
                        <div className="my-4 rounded overflow-hidden shadow-sm">
                            <img className="w-100 h-auto d-block" src={item.image1} alt={item.title} style={{ maxHeight: '500px', objectFit: 'cover' }} />
                        </div>
                    )}

                    <div className="article-body my-4 text-secondary">
                        <div dangerouslySetInnerHTML={{ __html: item.paragraph2 }} />
                    </div>

                    {item.image2 && (
                        <div className="my-4 rounded overflow-hidden shadow-sm">
                            <img className="w-100 h-auto d-block" src={item.image2} alt={item.title} style={{ maxHeight: '500px', objectFit: 'cover' }} />
                        </div>
                    )}

                    <div className="d-flex justify-content-center border-top pt-4 mt-5">
                        <SocialShareButtons title={item.title} onClick={handleShareClick} />
                    </div>
                </div>
            </div>

            {/* Other Departments Panel Section */}
            <section className="container my-5">
                <div className="mx-auto" style={{ maxWidth: '800px' }}>
                    <h4 className="fw-bold mb-3 px-2">Explore Other Departments</h4>
                    <div className="row g-3">
                        {departmentsList.map((dept) => (
                            <div className="col-12" key={dept.code}>
                                <div 
                                    className="card p-4 h-100 shadow-sm border d-flex flex-row justify-content-between align-items-center" 
                                    style={{ cursor: 'pointer', transition: 'all 0.2s' }}
                                    onClick={() => handleDepartmentNavigation(dept.code)}
                                    onMouseEnter={(e) => e.currentTarget.classList.add('border-success', 'bg-light')}
                                    onMouseLeave={(e) => e.currentTarget.classList.remove('border-success', 'bg-light')}
                                >
                                    <div>
                                        <h5 className="fw-bold mb-1 text-dark">{dept.name}</h5>
                                        <p className="text-muted small mb-0">View full curriculum, faculty, updates, and open vacancies</p>
                                    </div>
                                    <button className="btn btn-outline-primary rounded-pill btn-sm flex-shrink-0 ms-3 px-3">
                                        View More
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}